module.exports = __webpack_public_path__ + "static/media/window-restore.08843f83.svg";